import { render } from "./ServerOverviewComponent.vue?vue&type=template&id=05336877&scoped=true"
import script from "./ServerOverviewComponent.vue?vue&type=script&lang=js"
export * from "./ServerOverviewComponent.vue?vue&type=script&lang=js"

import "./ServerOverviewComponent.vue?vue&type=style&index=0&id=05336877&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05336877"]])

export default __exports__